import React from "react";
import { Box } from "@material-ui/core";
import { Typography } from "../atom/Typography";

function TermsAndConditionsPage(props) {
	return (
		<Box>
			<Typography>Terms and Conditions</Typography>
		</Box>
	)
}

TermsAndConditionsPage.displayName = "TermsAndConditionsPage";
export default TermsAndConditionsPage;
